import React, { Component } from "react";
import PropTypes from "prop-types";
import validator from "../Validators/Validators";
import http from "../Http/Http";
import "./ConfirmSignIn.css";

class ConfirmSignIn extends Component {
  constructor() {
    super();

    this.state = {
      confirmationCode: "",
      phoneNumber: "",
      errors: {
        confirmationCode: false
      },
      isSubmitted: false,
      paymentRequest: ""
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.signIn = this.signIn.bind(this);
  }

  componentDidMount() {
    const params = new URLSearchParams(this.props.location.search);
    const phoneNumber = params.get("phone");
    const paymentRequest = params.get("paymentRequest");

    this.setState({ phoneNumber, paymentRequest });
  }

  handleChange(event) {
    this.setState(
      {
        confirmationCode: event.target.value
      },
      () => {
        if (this.state.isSubmitted) {
          this.validateForm();
        }
      }
    );
  }

  validateForm(onValidForm) {
    const errors = {
      confirmationCode: !validator.isValidCode(this.state.confirmationCode)
    };

    this.setState({ errors });

    const errorKeys = Object.keys(errors).filter(key => errors[key]);

    // invoke callback function when form has no errors
    if (onValidForm && errorKeys.length === 0) {
      onValidForm();
    }
  }

  handleSubmit(event) {
    event.preventDefault();

    this.setState({ isSubmitted: true });
    this.validateForm(this.signIn);
  }

  signIn() {
    this.setState({ isSubmitting: true });

    const { phoneNumber, paymentRequest } = this.state;
    const navigateToUrl = `/` + (paymentRequest ? `s/${paymentRequest}` : "");

    http
      .get(`/wallet/$${phoneNumber}`)
      .then(response => {
        // get the default signer from the response
        const signerId = response.data.default;

        if (signerId) {
          return signerId;
        } else {
          throw Error("No default signer");
        }
      })
      .then(signerId => {
        return http.get(`/signer/${signerId}`);
      })
      .then(response => {
        const signerHandle = response.data.handle;
        const tag = response.data.labels.firstName;

        if (signerHandle && tag && phoneNumber) {
          return {
            signerHandle,
            tag,
            phoneNumber
          };
        }
      })
      .then(session => {
        this.props.onSignedIn(session);
        this.props.history.push(navigateToUrl);
      })
      .catch(error => {
        const errors = {
          phoneNumberNotExists: true
        };

        this.setState({ errors, isSubmitting: false });
      });
  }

  render() {
    return (
      <form className="confirm-signin" action="" onSubmit={this.handleSubmit}>
        <h1 className="confirm-signin-title">¡Ya casi terminamos!</h1>
        <p>
          Te hemos enviado un codigo de verificación al número de teléfono móvil{" "}
          <strong>+{this.state.phoneNumber}</strong>
        </p>
        <div>
          <label className="confirm-signin-label" htmlFor="confirmationCode">
            Código de confirmación
          </label>
          <input
            className="confirm-signin-input"
            id="confirmationCode"
            name="confirmationCode"
            type="number"
            placeholder="0000"
            value={this.state.confirmationCode}
            onChange={this.handleChange}
            aria-invalid={this.state.errors.confirmationCode}
            autoComplete="off"
          />
        </div>
        {this.state.errors.confirmationCode && (
          <div className="confirm-signin-error" aria-live="polite">
            Ingrese un código de 4 dígitos
          </div>
        )}
        {this.state.errors.phoneNumberNotExists && (
          <div className="confirm-signin-error" aria-live="polite">
            No existe una cuenta con este número de teléfono
          </div>
        )}
        <button className="confirm-signin-submit button-green">
          Continuar
        </button>
        <p className="confirm-signin--panel-resend-code">
          <strong>¿No has recibido el código de confirmación?</strong>
          <br />
          <button className="button-link" type="button">
            Solicita un nuevo código
          </button>
        </p>
      </form>
    );
  }
}

ConfirmSignIn.propTypes = {
  onSignedIn: PropTypes.func
};

export default ConfirmSignIn;



// WEBPACK FOOTER //
// ./src/ConfirmSignIn/ConfirmSignIn.js